import React from "react";
import styles from "./mortgage-cat.module.scss";
import HomebuddyMort from "../../assets/mortgage-homebuddy.svg";
import ExternalMort from "../../assets/mortgage-external.svg";
import FxMort from "../../assets/mortgage-fx.svg";
import EligilityMort from "../../assets/mortgage-eligibility.svg";
import { useHistory } from "react-router";
import { useAuth } from "../../contexts/AuthContext";

const MortgageCategories = () => {
  const history = useHistory();
  const { isAuthenticated } = useAuth();

  const list = [
    {
      text: "Mortgage Eligibility Status",
      color: "rgba(91, 35, 51, 0.2)",
      logo: EligilityMort,
      identifier: "ELIGIBILITY",
      redirect: "/j-eligibility",
    },
    {
      text: "HomeBuddy Mortgage Properties",
      color: "rgba(219, 84, 97, 0.2)",
      logo: HomebuddyMort,
      identifier: "HOMEBUDDY",
      redirect: "/mortgage?morf=homebuddy-mort",
    },
    { 
      text: "External Mortgage Properties",
      color: "rgba(32, 32, 48, 0.2)",
      logo: ExternalMort,
      redirect: "/external-eligibility?morf=external-mort",
    },
    {
      text: "FX Rate",
      color: "#F5F5F5",
      logo: FxMort,
      nav: "", // should be an empty string
      identifier: "FX",
      redirect: "",
    },
  ];

  ///bvn-verification
  return (
    <div className={styles.overallContainer}>
      <div className={styles.container}>
        {list.map((li) => (
          <div
            className={styles.griditem}
            key={li.text}
            role="button"
            onClick={() => {
              if (!li.redirect) return;

              // HomeBuddy properties are browsed first; BVN verification
              // now only starts once the user picks a specific property
              // and clicks "Apply for Mortgage" there.
              if (li.identifier === "HOMEBUDDY") {
                history.push(li.redirect);
                return;
              }

              localStorage.setItem("mortgage_redirect_path", li.redirect);
              if (
                li.identifier !== "ELIGIBILITY" &&
                !isAuthenticated
              ) {
                history.push(
                  `/signin?redirect=${encodeURIComponent("/bvn-verification")}`
                );
              } else {
                history.push("/bvn-verification");
              }
            }}
          >
            <div
              className={styles["grid-item-circle"]}
              style={{ backgroundColor: li.color }}
            >
              <img src={li.logo} />
            </div>
            <span className={styles["grid-item-text"]}>{li.text}</span>
            {li.identifier === "FX" ? (
              <div className={styles["griditem-grayed"]} />
            ) : (
              ""
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MortgageCategories;
